module.exports = __webpack_public_path__ + "img/adventure.22f9b16f.svg";